<template>
<div class="c-inquiry__body">
	<div class="inquiry-form__title-block">
		<p class="inquiry-form__form-title">{{msg.personal_info}}</p>
	</div>

	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name+(required_fields.first_name?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name+(required_fields.last_name?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="company_name" value="" class="inquiry-form__input-text" :placeholder="msg.company_name+(required_fields.company_name?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="address" value="" class="inquiry-form__input-text" :placeholder="msg.address+(required_fields.address?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="country" value="" class="inquiry-form__input-text" :placeholder="msg.country+(required_fields.country?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="phone" value="" class="inquiry-form__input-text" :placeholder="msg.phone+(required_fields.phone?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="country" value="" class="inquiry-form__input-text" :placeholder="msg.mobile_phone+(required_fields.country?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email+(required_fields.email?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="event_name" value="" class="inquiry-form__input-text" :placeholder="msg.event_name+(required_fields.event_name?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="number" name="total_people" value="" class="inquiry-form__input-text" :placeholder="msg.total_people+(required_fields.total_people?' *':'')">
			</label>
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-lg-6">
			<p class="inquiry-form__section-lebel ">{{msg.room_number+(required_fields.room_number?' *':'')}}</p>
			<div class="c-custom-select inquiry-form__select">
				<input type="number" name="room_number" value="" class="inquiry-form__input-text" :placeholder="msg.room_number">
				<!-- <multiselect :options="roomNumber" :searchable="false" v-model="numberOfRooms" :close-on-select="true" :show-labels="true"></multiselect>
				<input type="hidden" name="room_number" :value="numberOfRooms"> -->
			</div>
		</div>
		<!-- <div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="event_dates" value="" class="inquiry-form__input-text" :placeholder="msg.event_dates+(required_fields.event_dates?' *':'')">
			</label>
		</div> -->
		<div class="col-12 col-lg-6">
			<!-- insert datepicker -->
			<div class="inquiry-form__datepicker">
				<date-picker></date-picker>
				<input type="hidden" name="date_from" :value="dates[0]">
				<input type="hidden" name="date_to" :value="dates[1]">
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<textarea name="meeting_requirements" rows="8" cols="80" :placeholder="msg.meeting_requirements+(required_fields.meeting_requirements?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<textarea name="fb_requirements" rows="8" cols="80" :placeholder="msg.fb_requirements+(required_fields.fb_requirements?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<label class="inquiry-form__label">
				<textarea name="message" rows="8" cols="80" :placeholder="msg.message+(required_fields.message?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
	</div>

	<div class="inquiry-form__bottom">
		<div class="inquiry-form__opt">
			<label class="inquiry-form__label">
				<input type="hidden" name="gdpr_accept" value="false" class="inquiry-form__input-check">
				<input type="checkbox" name="gdpr_accept" value="true" class="inquiry-form__input-check">
				<span style="margin-left:5px;" v-html="msg.form_gdpr+(required_fields.gdpr_accept?' *':'')"></span>
			</label>
			<label class="inquiry-form__label">
				<input type="hidden" name="newsletter_accept" value="false" class="inquiry-form__input-check">
				<input type="checkbox" name="newsletter_accept" value="true" class="inquiry-form__input-check">
				<span style="margin-left:5px;" v-html="msg.form_newsletter+(required_fields.newsletter_accept?' *':'')"></span>
			</label>

		</div>

	</div>
</div>

</template>

<script>
// import Multiselect from 'vue-multiselect';
import { eventBus } from '../../main.js';
import { mapState } from "vuex";

	export default {
		props: {
			required_fields: Object
		},
		// components: {
		// 	Multiselect
		// },
		data() {
			return {
				roomNumber: Array.apply(null, {length: 10}).map(Number.call, Number),  
				numberOfRooms: 0,
				dates: [],
			}
		},
		computed: {
			...mapState({
				msg: state => state.msg,
			})
		},
		created() {
			eventBus.$on('date-changed', payload => {
				this.dates = payload;
			});
		}
	}
</script>

<style lang="scss">
.inquiry-form__datepicker  {
	.el-input__inner {

		border: none !important;
		width: 100%;
		height: 49px;
		box-shadow: inset 2px 0 0 0 #2a2c31;
  		background-color: #fff;
		outline: none;
		border: none;
		border-radius: 0;
		padding: 16px 22px;
		font-size: 1.4rem;
		line-height: 1.28571em;
		font-weight: 500;
		color: #171a23;
		max-width: 100%;
	}
	.el-range__icon {
		position: absolute;
		right: 0;
		transform: translateX(-25%);
	}
	.el-range-separator {
		line-height: 42px;
	}
}
</style>

<style lang="scss" scoped>
.inquiry-form__datepicker  {
	.daepicker-block {
		margin-bottom: 30px;
	}
}
</style>
